module.exports = __webpack_public_path__ + "static/media/sf-test-20.cb9a3200.mp3";